import { createContext } from 'react';
export const helpdeskDetailContext = createContext(null);
